import { Injectable } from '@angular/core';
import { User } from './user';

@Injectable({
  providedIn: 'root'
})
export class NgUserService {

  user : User = new User();

  constructor() { }
  
  /** replace with API when moving to full angular */
  initUser = (user : any) => this.user = user;
}
